var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideScanText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 21.75H15.9375V13.05H13.0625V21.75ZM14.5 10.15C14.9073 10.15 15.2489 10.0108 15.5249 9.7324C15.8009 9.454 15.9385 9.10987 15.9375 8.7C15.9375 8.28917 15.7995 7.94455 15.5235 7.66615C15.2475 7.38775 14.9063 7.24903 14.5 7.25C14.0927 7.25 13.7511 7.3892 13.4751 7.6676C13.1991 7.946 13.0615 8.29014 13.0625 8.7C13.0625 9.11084 13.2005 9.45545 13.4765 9.73385C13.7525 10.0123 14.0937 10.151 14.5 10.15ZM14.5 29C11.1698 28.1542 8.42033 26.2266 6.25163 23.2174C4.08292 20.2082 2.99904 16.8674 3 13.195V4.35L14.5 0L26 4.35V13.195C26 16.8683 24.9156 20.2096 22.7469 23.2189C20.5782 26.2281 17.8292 28.1551 14.5 29ZM14.5 25.955C16.9917 25.1575 19.0521 23.5625 20.6812 21.17C22.3104 18.7775 23.125 16.1192 23.125 13.195V6.34375L14.5 3.08125L5.875 6.34375V13.195C5.875 16.1192 6.68958 18.7775 8.31875 21.17C9.94792 23.5625 12.0083 25.1575 14.5 25.955Z",
    fill: "url(#paint0_linear_2560_3397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2560_3397",
    x1: 4.51613,
    y1: 5.8,
    x2: 21.0815,
    y2: 8.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411996,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideScanText);
export default __webpack_public_path__ + "static/media/lucide_scan-text.538f31318cf0877d659b80032c0e137c.svg";
export { ForwardRef as ReactComponent };